itsoftApp.createModule("insertMap", function () {
    var APIKEY = "d4d7994c-465c-4f96-bf4c-aabe2b09d8ca";
    var LANG = "ru_RU";
    // var parents = document.querySelectorAll(".js-map");
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;

    var initQueue = function() {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module insertMap] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };

    var loadAndInit = function() {
        var f = function() {
            libraryLoaded = true;
            initQueue();
        };

        if (typeof ymaps !== "undefined") {
            f();

        } else {
            itsoftApp.loadScript("https://api-maps.yandex.ru/2.1?apikey=" + APIKEY + "&load=package.full&lang=" + LANG, f);
        }
    };

    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {
            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };

    var initMapSection = function (mapSection) {
        var init = function () {
            var map;

            if (mapSection) {
                var mapDomElement = mapSection.querySelector(".js-map");
                var mapCanvas = mapDomElement.querySelector(".js-map-canvas");
                var mapId = mapCanvas.id;
                var mapControls = ["zoomControl"];
                var dataZoomAttribute = mapCanvas.getAttribute("data-zoom");

                ymaps.ready(function () {
                    var createMap = function () {
                        var dataPinAttribute = mapCanvas.hasAttribute("data-pin");

                        map = new ymaps.Map(mapId, {
                            center: [+mapCanvas.getAttribute("data-lat"), +mapCanvas.getAttribute("data-lng")],
                            zoom: +dataZoomAttribute || 10,
                            controls: mapControls
                        });

                        if (dataPinAttribute) {
                            var myGeoObject = new ymaps.Placemark(
                                [+mapCanvas.getAttribute("data-lat"), +mapCanvas.getAttribute("data-lng")],
                                {},
                                {
                                    // Опции.
                                    // Необходимо указать данный тип макета.
                                    // iconLayout: "default#image",
                                    preset: "islands#redDotIcon"
                                    // Своё изображение иконки метки.
                                    // iconImageHref: "/media/images/map-pin.png",
                                    // Размеры метки.
                                    // iconImageSize: [20, 30],
                                    // Смещение левого верхнего угла иконки относительно
                                    // её "ножки" (точки привязки).
                                    // iconImageOffset: [-10, -30]
                                });

                                map.geoObjects.add(myGeoObject);
                        }
                    }

                    createMap();
                });
            }
        }

        addEvent(init);

        DEBUG && console.log("%c--[module map] delegating loadAndInit to pageLoad module", "font-style: italic; color: #999");
    }

    module.callback = function (mapSection) {
        initMapSection(mapSection);
    }
});
